import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
} from '@mui/material';
import { useTranslationContext } from '../hooks/translationsProvider';
import { GREEN_MAIN, WHITE } from '../theme/colors';
import { ESex } from '../models/authmodels';

interface SexSelectProps {
  sex: ESex | undefined;
  setSex: (value: ESex) => void;
  sexError: boolean;
  setSexError: (value: boolean) => void;
}

const SexSelect: React.FC<SexSelectProps> = ({
  sex,
  setSex,
  sexError = false,
  setSexError,
}) => {
  const {t} = useTranslationContext();
  const handleChange = (event: any) => {
      const value = event.target.value;
          setSex(value);
      if (setSexError) {
          setSexError(!value); // errore solo se è vuoto (ma in realtà non dovrebbe accadere)
      }
  };

  const handleBlur = () => {
    if (sex !== ESex.Male && sex !== ESex.Female) {
      setSexError(true);
    }else{
      setSexError(false);
    }
  };

  return (
    <FormControl fullWidth variant="outlined" error={sexError}>
        <InputLabel id="demo-simple-select-label"
            sx={{
                fontSize: '0.95em',
                backgroundColor:WHITE,
                // padding:"0 5px",
            }}
        >{!sexError ? t("Sesso"): t("Errore")}</InputLabel>
        <Select
            labelId="sex-label"
            value={sex}
            onChange={handleChange}
            onBlur={handleBlur}
            size="small"
            sx={{
                height:45,
                marginTop:"16px",
                marginBottom:"8px",
                fontSize: '1em',
                color:GREEN_MAIN
            }}
        >
            <MenuItem value={ESex.Male} sx={{ fontSize: '1em' }}>M</MenuItem>
            <MenuItem value={ESex.Female} sx={{ fontSize: '1em' }}>F</MenuItem>
        </Select>
        {/* {sexError && (
          <FormHelperText>Seleziona un sesso valido</FormHelperText>
        )} */}
    </FormControl>
  );
};

export default SexSelect;
